import z from 'zod';
import { scopedEntity, alarmRef, string, longString, } from '../common';
import { user } from './user';
import { namedCustomerRef } from './customer';
export var AlarmEventType;
(function (AlarmEventType) {
    AlarmEventType["User"] = "user";
    AlarmEventType["System"] = "system";
    AlarmEventType["Action"] = "action";
    AlarmEventType["Hidden"] = "hidden";
})(AlarmEventType || (AlarmEventType = {}));
export const alarmEvent = z.object({
    ...scopedEntity.shape,
    customer: namedCustomerRef,
    alarm: alarmRef,
    user: user.nullable(),
    text: longString,
    type: z.nativeEnum(AlarmEventType),
    action: string,
    meta: z.record(z.unknown()).optional(),
});
